import PropTypes from 'prop-types';
import React from 'react';

import { AdminPage } from '../lib/admin_layout';
import connect from 'components/lib/connect';
import styled from 'styled-components';
import TeamsProvider from 'components/admin/users/teams_provider';
import TeamsSection from 'components/admin/users/teams_section';
import UsersSection from 'components/admin/users/users_section';

function UsersPage({ isTeamManagementEnabled }) {
  if (!isTeamManagementEnabled) {
    return null;
  }

  return (
    <AdminPage>
      <UsersAdmin data-aid="usersAdmin">
        <TeamsProvider>
          <TeamsSection />
          <UsersSection />
        </TeamsProvider>
      </UsersAdmin>
    </AdminPage>
  );
}

UsersPage.propTypes = {
  isTeamManagementEnabled: PropTypes.bool,
};

export { UsersPage };

const UsersAdmin = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;

export default connect(mapStateToProps)(UsersPage);

function mapStateToProps({ isFeatureEnabled }) {
  return {
    isTeamManagementEnabled: isFeatureEnabled('teamManagement'),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/users_page.jsx